import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Text } from '@ps-design-system/components/Text';
import { Button } from '@ps-design-system/components/Button';
import LightbulbIcon from '@ps-design-system/icons/Lightbulb/Lightbulb20';
import ChevronLeftIcon from '@ps-design-system/icons/ChevronLeft/ChevronLeft20';

import { useUploadModal } from '../../context/UploadModalContext';
import { useUploaderPageData } from '../../context/UploaderPageContext';

const UploaderHeaderMobile = () => {
  const { listingId, isListing, spaceId, router } = useUploaderPageData();
  const { openTipsModal } = useUploadModal();

  const handleBackClick = () => {
    if (isListing) {
      router.push(`/mylistings/${listingId}`);
    } else {
      window.location.href = `/your-space/${spaceId}`;
    }
  };

  return (
    <div className="uploader-header">
      <div className="back-button">
        <Button variant="ghost" prefix={<ChevronLeftIcon />} onClick={handleBackClick} attributes={{ 'data-testing-id': 'upload-page-back' }}>
          <Text typeface="body-2">
            <FormattedMessage id="uploader.page.back" defaultMessage="Back"/>
          </Text>
        </Button>
      </div>

      <div className="title">
        <div>
          <Text typeface="headline-4-b">
            <FormattedMessage id="uploader.page.header" defaultMessage="Photos and videos"/>
          </Text>
        </div>
        <div>
          <Button
            appearance="white"
            variant="outline-1"
            shape="circle"
            className="tw-rounded-full"
            iconOnly
            onClick={openTipsModal}
          >
            <LightbulbIcon />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UploaderHeaderMobile;
